import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from '../images/logo.png';
import satnar from '../images/satnar.png';

function Header() {

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        document.body.classList.add("header-scrolled");
      } else {
        document.body.classList.remove("header-scrolled");
      }
    };

    // Scroll listener add
    window.addEventListener("scroll", handleScroll);

    // Cleanup listener remove on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className={`header ${menuOpen ? "active" : ""}`}>
      <div className="container page_wrapper">
        <div className="logo">
          <img src={logo} width="65" height="44" alt="Cubex Logo" />
          <span>Akash Sen</span>
        </div>

        <div className="top_menued">
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <div className="menu-icon">
              <span className="bars">
                <i className="bar half"></i>
                <i className="bar"></i>
                <i className="bar"></i>
              </span>
              <span className="menu-text">Menu</span>
            </div>
          </div>

          <div className="contact-link">
            <Link to="/contact">Contact
              <span className="external-icon">
                {/* svg... */}
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className={`mega_menu ${menuOpen ? "active" : ""}`}>
        <div className='page_wrapper'>
          <div className='flex'>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
            </ul>

            <div className='satnar_img'>
              <img src={satnar} alt="Satnar" width={500} height={500} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;